var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMeta(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0C1.79086 0 0 1.79086 0 4V12C0 14.2091 1.79086 16 4 16H12C14.2091 16 16 14.2091 16 12V4C16 1.79086 14.2091 0 12 0H4Z",
    fill: "#656380"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.78705 2.32601C8.35238 1.89133 7.64762 1.89133 7.21294 2.32601L5.03465 4.5043L8 7.46965L10.9653 4.5043L8.78705 2.32601Z",
    fill: "#656380"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4957 5.03463L8.53033 7.99998L11.4957 10.9653L13.674 8.78705C14.1087 8.35238 14.1087 7.64762 13.674 7.21294L11.4957 5.03463Z",
    fill: "#656380"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9654 11.4957L8 8.53031L5.03463 11.4957L7.21294 13.674C7.64762 14.1087 8.35238 14.1087 8.78705 13.674L10.9654 11.4957Z",
    fill: "#656380"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5043 10.9653L7.46967 7.99998L4.50432 5.03463L2.32601 7.21294C1.89133 7.64762 1.89133 8.35238 2.32601 8.78705L4.5043 10.9653Z",
    fill: "#656380"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeta);
export default __webpack_public_path__ + "static/media/meta.0b19182f2e60ebe3086c6ef25e5b4692.svg";
export { ForwardRef as ReactComponent };